import Vue from 'vue'
import Vuex from 'vuex'
// import { stat } from 'fs';

import sample from './modules/sample';
import user from './modules/user';
import dialog from './modules/dialog';

import websheet from './modules/websheet';
import smicroscopy from './modules/smicroscopy';
import subjectfinalstatus from './modules/subjectfinalstatus';
import subjectfinalstatuscompleted from './modules/subjectfinalstatuscompleted';
import structurefinalstatus from './modules/structurefinalstatus';
import structurefinalstatuscompleted from './modules/structurefinalstatuscompleted';
import subjectsreferred from './modules/subjectsreferred';
import subjects_past_due from './modules/subjects_past_due';
import incomplete_visits from './modules/incomplete_visits';
import formdateerrors from './modules/formdateerrors';
import overduetreatment from './modules/overduetreatment';
import microscopy_qc_count from './modules/microscopy_qc_count';
import supervisor_requests from './modules/supervisor_requests_count';
import new_compound_count from './modules/newcompound';

import adverseevents from './modules/adverseevents';
import products from './modules/products';

import { HTTP } from '@/utilities/http-common';

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    sample: sample,
    user: user,
    dialog: dialog,
    websheet: websheet,
    smicroscopy: smicroscopy,
    subjectfinalstatus: subjectfinalstatus,
    structurefinalstatus: structurefinalstatus,
    structurefinalstatuscompleted: structurefinalstatuscompleted,
    subjects_past_due: subjects_past_due,
    subjectfinalstatuscompleted: subjectfinalstatuscompleted,
    incomplete_visits: incomplete_visits,
    subjectsreferred: subjectsreferred,
    formdateerrors: formdateerrors,
    overduetreatment: overduetreatment,
    microscopy_qc_count: microscopy_qc_count,
    supervisor_requests: supervisor_requests,
    adverseevents: adverseevents,
    products: products,
    new_compound_count: new_compound_count,
  },
  state: {
    component: 'BaseTemplate',
    Authorization: '',
    // loginDialog: false,
    
    // messageDialog: false,
    // messageDialogMessage: 'An error occured!',

    // loadingDialog: false,
    // loadingDialogMessage: ''

    sidebar: true,

  },
  getters: {
    getBaseComponent: state => {
      return state.component;
    },
    isAuthenticated: state => {
      return (state.Authorization) ? true : false;
    },
    hasAuthorizationToken: state => {
      let Authorization = window.localStorage.getItem('Authorization');
      if (Authorization) {
        state.Authorization = Authorization;
        return true;
      } else {
        return false;
      }
    },
    getAuthorizationToken: state => {
      return state.Authorization;
    },
    getAuthorizationHeader: (state, getters) => {
      return (state.Authorization) ? { Authorization: getters.getAuthorizationToken} : {};
    }
  },
  mutations: {
    setBaseComponent (state, component) {
      state.component = component;
    },
    setAuthorizationToken (state, payload) {
      state.Authorization = payload.token_type + ' ' + payload.access_token;
      HTTP.defaults.headers.common['Authorization'] = state.Authorization;
      window.localStorage.setItem('Authorization', state.Authorization);
    },
    setAuthorization (state, payload) {
      state.Authorization = payload;
    },
    clearAuthorizationToken (state) {
      state.Authorization = '';
      window.localStorage.removeItem('Authorization');
      HTTP.defaults.headers.common['Authorization'] = undefined;
    },
    toggleSidebar: (state) => {
      state.sidebar = !state.sidebar;
    }
  },
  actions: {
    setAuthorizationToken ({commit}, payload) {
      commit('setAuthorizationToken', payload);
    },
    clearAuthorizationToken({commit}) {
      commit('clearAuthorizationToken');
    },
    setBaseComponent ({commit}, component) {
      commit('setBaseComponent', component);
    },
    initApp({dispatch}) {
      dispatch('initAuthorizationToken');
    },
    initAuthorizationToken({commit}) {
      let Authorization = window.localStorage.getItem('Authorization');
      if (Authorization) {
        commit('setAuthorization', Authorization);
      } else {
        return false;
      }
    },
    toggleSidebar({commit}) {
      commit('toggleSidebar');
    },

  }
})
